import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-03/lesson-15/task-01";

const task: Slide = {
  titleHtml:
    "One of the many applications of BTPA is finding the mechanical source and transfer<br>path responsible for an annoying component in a car noise. In this task you will use<br>BTPA to reach the source of an annoying sound. Below are spectograms of structure borne<br>and air borne sound components. Is the rattle noise primarily structure borne or air borne sound?",
  description: "Select the correct answer.",
  layout: {
    type: "table",
    options: {
      cols: 3,
      rows: 2,
      colSpan: {
        "1:0": 2,
      },
      rowSpan: {
        "0:2": 2,
      },
      rowsSize: [1, 8],
      colsSize: [4, 4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  url: `${config.ASSETS_URL}/03/15/task/structure-borne.wav`,
                  theme: "secondary",
                  icon: "cis-volume-high",
                  text: "Play",
                  shape: "round",
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  url: `${config.ASSETS_URL}/03/15/task/airborne.wav`,
                  theme: "secondary",
                  icon: "cis-volume-high",
                  text: "Play",
                  shape: "round",
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/15/task/scale.svg`,
                },
              },
              styles: {
                height: "350px",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
